// extracted by mini-css-extract-plugin
module.exports = {"pageNumbers":"style_pageNumbers__2I7VR","active":"style_active__312lw","currentPagebox":"style_currentPagebox__x-Z3z","newButton":"style_newButton__3prgq"};